import { Company } from '@aibees/elephant/feature/search-table-company';
import { capitalize } from '@aibees/shared/utils';
import ISO6391 from 'iso-639-1';

export function useCompanyLanguages(languages: Company['languages']) {
  const summary = languages
    ?.map((lang) => ISO6391.getCode(lang).toUpperCase() || capitalize(lang))
    .join(', ');
  const full = capitalize(languages?.join(', '));
  return { summary, full };
}
